import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ITimeClockEvent } from '~/utils/interface/timeClock';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';
import { handleGetTimeClocks, handleGetTimeClocksSelection } from './timeClocksThunk';
import { SortField } from '~/utils/types/common';
import { IMasterDataItem } from '~/utils/interface/master';

export interface TimeClocksState {
  timeClocks: Array<ITimeClockEvent>;
  timeClocksSelection: Array<IMasterDataItem>;
  currentPage: number;
  totalPages: number;
  selectedIds: Array<string>;
  menuSelectedId: string | undefined;
  openAlertDelete: boolean;
  needRefreshData: boolean;
  filter: ITimeclockFilter;
  currentTimeClock?: ITimeClockEvent;
}

export interface ITimeclockFilter {
  page?: number;
  limit?: number;
  search?: string;
  searchFields?: Array<string>;
  sort?: Array<SortField>;
  startDate?: string;
  endDate?: string;
  createdBy?: Array<string>;
  isExport?: boolean;
}

const initialState: TimeClocksState = {
  timeClocks: [],
  timeClocksSelection: [],
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  menuSelectedId: undefined,
  selectedIds: [],
  openAlertDelete: false,
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    search: '',
    searchFields: [],
    sort: [],
  },
  currentTimeClock: undefined,
};

const timeClocksSlice = createSlice({
  name: 'timeClocks',
  initialState,
  reducers: {
    setFilter(state, action: PayloadAction<ITimeclockFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    setFilterProperty(
      state,
      action: PayloadAction<{ key: keyof ITimeclockFilter; value: ITimeclockFilter[keyof ITimeclockFilter] }>
    ) {
      if (state.filter[action.payload.key] !== action.payload.value) {
        state.filter = { ...state.filter, ...{ [action.payload.key]: action.payload.value } };
      }
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
    },
    changeMenuSelectId(state, action: PayloadAction<string>) {
      state.menuSelectedId = action.payload;
    },
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetTimeClocks.pending, (state, action) => {
        state.selectedIds = [];
      })
      .addCase(handleGetTimeClocks.fulfilled, (state, action) => {
        state.timeClocks = [...action.payload.responses];
        state.currentPage = action.payload.pagination.page;
        state.totalPages = action.payload.pagination.totalPages;
        state.needRefreshData = false;
        state.currentTimeClock = action.payload?.meta?.currentTimeClock;
      })
      .addCase(handleGetTimeClocks.rejected, (state, action) => {});
    builder.addCase(handleGetTimeClocksSelection.fulfilled, (state, action) => {
      state.timeClocksSelection = [...action.payload.responses];
    });
  },
});

export const timeClocksActions = timeClocksSlice.actions;

const timeClocksReducer = timeClocksSlice.reducer;
export default timeClocksReducer;
